<template>
    <div class="pl-4">
        <div v-if="isLoginGuest" class="topbar-height flex items-center">
            <router-link :to="routeLogin" class="block text-12 text-a-egg-f5ebdc bg-a-brown-502314 rounded-full py-1 px-2 cursor-pointer">
                {{ lbl.main.signin }}
            </router-link>
        </div>
        <div v-else class="topbar-height flex items-center">
            <div v-if="isRewardPage">
                <div class=" text-a-egg-f5ebdc text-12 font-bold bg-a-brown-502314 rounded-full px-2 py-1 cursor-pointer" @click="clickMyCoupon()">{{lbl.profile.my_coupon}}</div>
            </div>
            <div v-else class="flex">
                <div @click="clickReward()" class="label-crown text-a-egg-f5ebdc text-12 mr-0 flex justify-center items-center">
                    {{userPoint}}
                </div>
                <div class="relative" @click="clickNoti()">
                    <img class="w-6 cursor-pointer" src="../../../../../assets/noti/ic-Noti.svg">
                    <div v-if="notiCount > 0" class="label-noti cursor-pointer bg-a-red-d62300 absolute text-a-egg-f5ebdc text-12 rounded-full">
                        {{notiCount}}
                    </div>
                </div>
            </div>
            
        </div>
    </div>
</template>
<script>
import { inject } from 'vue';
import { useRoute } from 'vue-router';
import AuthStatusMixin from '@/mixin/AuthStatusMixin';
import LocaleMixin from "@/mixin/LocaleMixin.js";

export default {
    mixins: [AuthStatusMixin,LocaleMixin],
    inject: ["SideMenuStore"],
    data: function () {
        return {

        };
    },
    computed: {
        routeLogin: function () {
            let path = this.$route.path;
            return '/login?afterLogin=' + path;
        },
    },
    setup: function(){
        const { count: notiCount , methods: notiMethods } = inject("NotificationStore")

        const route = useRoute()

        const isRewardPage = route.name === 'reward'
        return {
            isRewardPage,
            notiCount,
            notiMethods
        }
    },
    methods: {
        clickNoti: function () {
            console.log('click noti');
            this.tracking.event('homepage','click notification')

            this.notiMethods.readAll().subscribe({
                next: () => {
                    this.SideMenuStore.methods.toggleSideMenu("notification", true);
                },
                error: (err) => {
                    console.log(err)
                    // do nothing
                }
            });
        },
        clickReward: function () {
            this.$router.push("/reward");
        },
        clickMyCoupon: function () {
            this.$router.push("/mycoupon");
        }
    },
}
</script>
<style lang="scss" scoped>

    @import "@/style/base/base.scss";
    .topbar-height {
        height: $topbar-height;
    }
    .label-noti {
        padding: 2px 8px;
        top: -3px;
        right: -12px;
    }
    .label-crown {
        padding-top: 7px;
        width: 50px;
        height: 30px;
        background-image: url('../../../../../assets/icon/crown-red.svg');
        background-repeat: no-repeat;
        background-size: 38px;
        background-position-x: center;
        background-position-y: center;
    }
</style>
